<template>
  <td v-if="renderCell" :class="className" >
    <div class="flex flex-wrap">
      <rounded-tag v-for="tag in value" :key="tag" :tag="tag" :format="format" :field="field" :extraparams="extraparams" />
    </div>
  </td>
  <td v-else-if="renderArrow" :key="'g' + columnIndex" :class="'k-group-cell'" />
  <td v-else-if="columnIndex <= level" key='g-colspan' :colSpan="columnsCount - columnIndex">
    <p class='k-reset'>
      <a @click="onGroupClick" tabIndex='-1' href='#' :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import moment from 'moment'
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'
import RoundedTag from '@/components/kendo/templates/RoundedTag.vue'

export default {
  components: { RoundedTag },
  name: 'tags-template',
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      tags: ['tag1']
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    tagsValues () {
      return getNestedValue(this.field, this.dataItem)
    },
    value: function () {
      return getNestedValue(this.field, this.dataItem)
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return value
    },
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    onGroupClick (e) {
      // @ts-ignore
      this.$emit('groupclick', e, this.dataItem, this.expanded)
    },
    formatTags: function (strDate) {
      if (!this.isEmptyArray(strDate)) return ' - '
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    isEmptyArray: function (arrayTags) {
      if (arrayTags === undefined || arrayTags === null || arrayTags.length === 0) return true
      return false
    },
    getNestedValue: getNestedValue
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
.tag-cell{
  border-color: var(--Tag-border-)!important;
}
</style>
